<template>
  <Countdown
    #default="{ indicatorPercentage, skipCountdown }"
    @countdownFinished="$router.replace({ name: 'questions' })"
  >
    <ViewWrapper class="focused_countdown" @click="skipCountdown">
      <section class="focused_countdown__inner">
        <!-- TODO: move ProgressFrameBar in page wrapper component and wait for animationend event until it dissappears -->
        <ProgressFrameBar :indicator-percentage="indicatorPercentage" />

        <h2 class="focused_countdown__info">
          {{ $t('view.focusCountdown.stayFocusedKeepPace') }}<br />
          <b class="typo_hl">{{ $t('view.focusCountdown.lastMinute') }}</b>
        </h2>
      </section>
    </ViewWrapper>
  </Countdown>
</template>

<script>
import Countdown from '../components/Countdown';
import ProgressFrameBar from '../components/ProgressFrameBar';
import ViewWrapper from '../components/ViewWrapper';

import { playSound } from '../services/sound';

export default {
  name: 'FocusedCountdown',

  components: {
    Countdown,
    ProgressFrameBar,
    ViewWrapper,
  },

  mounted() {
    playSound('fxA', 'headline');
  },
};
</script>

<style lang="scss" scoped>
.focused_countdown {
  background-color: rgba($color-black, $view-overlay-alpha);
}

.focused_countdown__inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.focused_countdown__info {
  @include module-headline;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
}
</style>
